import script from "./VODNav.vue?vue&type=script&setup=true&lang=js"
export * from "./VODNav.vue?vue&type=script&setup=true&lang=js"

import "./VODNav.vue?vue&type=style&index=0&id=67f1f10e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67f1f10e"]])

export default __exports__